import { observer } from "mobx-react";
import { OptionFieldModel } from "../../common/commonForms";
import { ShareholderFollowUpItem } from "./shareholdersFollowUpDomain";
import { useTranslation } from "../../stores/RootStoreContext";
import { Dialog } from "../../components-v2/Dialog";
import { Box, VBox } from "../../components-v2/Box";
import { Table } from "../../components-v2/Table";
import { LinkButton } from "../../components-v2/Button";
import { Checkbox } from "../../components-v2/Checkbox";

export const ShareholderFollowUpReviewDialog = observer(function ReviewDialog({
  model,
  onCancel,
  onSubmit,
  isSubmitting,
}: {
  model: OptionFieldModel<ShareholderFollowUpItem>;
  onCancel?: () => void;
  onSubmit?: () => void;
  isSubmitting: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      onCancel={onCancel}
      onSubmit={onSubmit}
      title={{ key: "followup.shareholders.dialog-header" }}
      isSubmitDisabled={model.isNoneSelected}
      submitLabel={{
        key: "followup.shareholders.dialog-submit-button",
        params: { count: model.selectedIds.size },
      }}
      isSubmitting={isSubmitting}
    >
      <VBox gap={"lg"}>
        <p>{t("followup.shareholders.dialog-text", { count: model.options.length })}</p>
        <Table variant={"IN_CARD"}>
          <thead>
            <tr>
              <td>
                <LinkButton
                  label={{ key: "followup.shareholders.header-select-all" }}
                  onClick={() => (model.isAllSelected ? model.setSelected([]) : model.selectAll())}
                />
              </td>
              <td>
                <Box textSize={"normal"} fontWeight={"bold"} fg={"default"}>
                  {t("followup.shareholders.header-change")}
                </Box>
              </td>
            </tr>
          </thead>
          <tbody>
            {model.options.map((s, index) => (
              <tr key={`${s.companyNumber}-${index}`}>
                <td>
                  <Box gap={"md"}>
                    <Checkbox
                      checked={model.isSelected(s)}
                      onChange={() => model.toggle(s)}
                      id={s.companyNumber}
                    />
                    <label htmlFor={s.companyNumber}>
                      {s.companyName} ({s.companyNumber})
                    </label>
                  </Box>
                </td>
                <td>
                  <label htmlFor={s.companyNumber}>
                    {t("followup.shareholders.update-company-name", { name: s.brName })}
                  </label>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </VBox>
    </Dialog>
  );
});
